<template>
  <span
    v-if="status_id == 0"
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20"
  >
    {{ prepend_label }} Preparando
  </span>
  <span
    v-if="status_id == 1"
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-[#f0f4e8] text-[#3d5218] ring-1 ring-inset ring-[#5c7a2e]/20"
  >
    {{ prepend_label }} Cargado
  </span>
</template>

<script>
export default {
  name: "AEProductionQueryContainerExportContainerStatus",
  props: ["status_id", "prepend_label"]
};
</script>
